import React, { useEffect, useState } from 'react';
import VehicleCard from '../../components/VehicleCard/VehicleCard';
import { useOutletContext } from 'react-router-dom';
import Swal from 'sweetalert2';
import './CatalogPage.css';
import { showVehicle, filterVehicles, sortVehicles, getVehicles } from '../../services/VehicleServices';

const CatalogPage = () => {

  const { vehicles, setVehicles } = useOutletContext(); 
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [filter, setFilter] = useState({ type: '', fuel: '' });
  const [sortKey, setSortKey] = useState(''); 
  const [sortOrder, setSortOrder] = useState('asc');

  useEffect(() => {
    async function fetchVehicles() {
      const fetchedVehicles = await getVehicles();
      setVehicles(fetchedVehicles);
    }
    fetchVehicles();
  }, [setVehicles]);


  useEffect(() => {
    let filtered = filterVehicles(vehicles, filter);
    if (sortKey) {
      filtered = sortVehicles(filtered, sortKey, sortOrder);
    }
    setFilteredVehicles(filtered);
  }, [filter, vehicles, sortKey, sortOrder]);

  const handleFilterChange = (e) => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.value
    });
  };

  const handleSortChange = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortOrder('asc');
    }
  };

  return (
    <div className="catalog-container">
      <h2>Mezzi in Vendita</h2>
      <div className="filter-container">
        <select name="type" value={filter.type} onChange={handleFilterChange}>
          <option value="">Tutti i tipi</option>
          <option value="Furgone">Furgone</option>
          <option value="Automobile">Automobile</option>
        </select>
        <select name="fuel" value={filter.fuel} onChange={handleFilterChange}>
          <option value="">Tutti i carburanti</option>
          <option value="Diesel">Diesel</option>
          <option value="Benzina">Benzina</option>
          <option value="Ibrido">Ibrido</option>
          <option value="Elettrico">Elettrico</option>
          <option value="Gas">Gas</option>
          <option value="Benzina-Gas">Benzina-Gas</option>
        </select>
      </div>
      <div className="sort-container">
        <button onClick={() => handleSortChange('price')}>
          Ordina per Prezzo {sortOrder === 'asc' ? '⬆️' : '⬇️'}
        </button>
        <button onClick={() => handleSortChange('km')}>
          Ordina per Chilometraggio {sortOrder === 'asc' ? '⬆️' : '⬇️'}
        </button>
        <button onClick={() => handleSortChange('matriculation')}>
          Ordina per Data di Immatricolazione {sortOrder === 'asc' ? '⬆️' : '⬇️'}
        </button>
      </div>
      <div className="vehicle-list">
        {filteredVehicles.map(vehicle => (
          <VehicleCard key={vehicle.id} vehicle={vehicle} onClick={() => showVehicle(vehicle, Swal)} />
        ))}
      </div>
    </div>
  );

};

export default CatalogPage;